export const FOOTER_MENU_UPDATED_EVENT = "familysafe:footer-menu-updated";

export const notifyFooterMenuUpdated = () => {
  window.dispatchEvent(new Event(FOOTER_MENU_UPDATED_EVENT));
};
